import { useState } from 'react';

const useLoading = () => {
    const [loading, setLoading] = useState(false);
    const [tip, setTip] = useState('');

    const toggle = (msg) => {
        if (msg) {
            setTip(msg);
            setLoading(true);
        } else {
            setTip('');
            setLoading(false);
        }
    };

    return {
        loading,
        tip,
        toggle,
    };
};

export default useLoading;

//for selected section loading
